import script from "./HospitalBillAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./HospitalBillAdd.vue?vue&type=script&setup=true&lang=js"

import "./HospitalBillAdd.vue?vue&type=style&index=0&id=f9fdcac4&lang=css"
import "./HospitalBillAdd.vue?vue&type=style&index=1&id=f9fdcac4&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9fdcac4"]])

export default __exports__